import { BreadCrumbModel } from '@/models/breadcrumb';
import i18n from '@/plugins/i18n';

const Breadcrumbs = {
  mazadat: [{
    external: true,
    text: i18n.t('breadcrumb.eServices'),
    href: '/applications/landing/e-services',
  },
  {
    text: i18n.t('breadcrumb.mazadat'),
    href: '/',
  },
  ] as BreadCrumbModel[],

  mazadDetails: [{
    external: true,
    text: i18n.t('breadcrumb.eServices'),
    href: '/applications/landing/e-services',
  },
  {
    text: i18n.t('breadcrumb.mazadat'),
    href: '/mazadat/',
  },
  {
    text: i18n.t('breadcrumb.mazadDetails'),
    href: '/',
  },
  ] as BreadCrumbModel[],

  easarLists: [{
    external: true,
    text: i18n.t('breadcrumb.eServices'),
    href: '/applications/landing/e-services',
  },
  {
    text: i18n.t('breadcrumb.easar'),
    href: '/',
  },
  ] as BreadCrumbModel[],

  easarDetails: [{
    external: true,
    text: i18n.t('breadcrumb.eServices'),
    href: '/applications/landing/e-services',
  },
  {
    text: i18n.t('breadcrumb.easar'),
    href: '/easar',
  },
  {
    text: i18n.t('breadcrumb.easarDetails'),
    href: '/',
  },
  ] as BreadCrumbModel[],

  provenEasarList: [{
    external: true,
    text: i18n.t('breadcrumb.eServices'),
    href: '/applications/landing/e-services',
  },
  {
    text: i18n.t('breadcrumb.provenEasarat'),
    href: '/',
  },
  ] as BreadCrumbModel[],

  moneyReservation: [{
    external: true,
    text: i18n.t('breadcrumb.eServices'),
    href: '/applications/landing/e-services',
  },
  {
    text: i18n.t('breadcrumb.moneyReservation'),
    href: '/',
  },
  ] as BreadCrumbModel[],

  moneyReservationDetails: [{
    external: true,
    text: i18n.t('breadcrumb.eServices'),
    href: '/applications/landing/e-services',
  },
  {
    text: i18n.t('breadcrumb.moneyReservation'),
    href: '/money-reservation',
  },
  {
    text: i18n.t('breadcrumb.moneyReservationDetails'),
    href: '/',
  },
  ] as BreadCrumbModel[],
};

export default Breadcrumbs;
